module.exports = __webpack_public_path__ + "img/dt2.7267990f.png";